import { useEffect } from 'react'

import FullScreenPage from '../../components/FullScreenPage/FullScreenPage'
import { useAppState } from '../../context/appStateContext'
import { PromoProvider } from '../../context/promoContext'
import styles from './LimitedTimePaywall.module.scss'
import LimitedTimePaywallBottom from './LimitedTimePaywallBottom/LimitedTimePaywallBottom'
import LimitedTimePaywallTop from './LimitedTimePaywallTop/LimitedTimePaywallTop'

const LimitedTimePaywall = () => {
  const { state, actions } = useAppState()
  useEffect(() => {
    actions.setHeaderInsetColor("#0A1416")
    actions.setFooterInsetColor("#15253b")
  }, [])

  if (!state.fullyLoaded) {
    return <div>Loading</div>
  }

  return (
    <PromoProvider>
      <FullScreenPage containerClassName={styles.container}>
        <LimitedTimePaywallTop containerClassName={styles.top} />
        <LimitedTimePaywallBottom containerClassName={styles.bottom} />
      </FullScreenPage>
    </PromoProvider>
  )
}

export default LimitedTimePaywall
